import { Router } from '@/legacy/Router';
import theme from './theme';

Router.get('theme', theme);
